// extracted by mini-css-extract-plugin
export default {"chart":"ProductViews_chart__X0Iba"};